import {useCallback} from 'react'

import {trackEvent} from '../../../../../common/analytics'

export const useTrackPalletSizeChange = () => {
  const trackPalletSizeChange = useCallback((quantity: number) => {
    trackEvent('hubOrderIntakeBulkBaggedCementPalletSizeChange', {
      quantity,
      dateTime: new Date().toISOString()
    })
  }, [])

  return trackPalletSizeChange
}
